export type EnergyStudyInterest = "unknown" | "interested" | "not_now";

export function energyStudyConsentControl(interest: EnergyStudyInterest, consent: boolean) {
  const enabled = interest === "interested";
  return { enabled, checked: enabled && consent };
}
